import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Loader from '../../../components/Loader';
import axios from 'axios';
import params from '../../../config/Params';
import { getItemFromLocalStorage } from '../../../utils/storageUtils';
import { toast } from 'react-toastify';

const AccountType = ({ formData, setFormData }) => {
    const [loading, setLoading] = useState(true);
    const [accountTypes, setAccountTypes] = useState([]);
    const [roles, setRoles] = useState([]);
    const [selectedTypeId, setSelectedTypeId] = useState(formData.accountType ? formData.accountType.id : null);

    const [localFormValues, setLocalFormValues] = useState({
        first_name: formData.first_name || '',
        last_name: formData.last_name || '',
        business_name: formData.business_name || '',
        role_id: formData.role_id || '',
    });

    useEffect(() => {
        const fetchBaseData = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            const requestFormData = new FormData();
            requestFormData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.payoutBaseData}`,
                    data: requestFormData
                });

                if (response.data.status === 'found') {
                    setAccountTypes(response.data.account_holder_type || []);
                    setRoles(response.data.account_holder_roles || []);
                } else {
                    toast.error('Unable to fetch account types.');
                }
            } catch (error) {
                toast.error(error.message || 'Failed to load account type data.');
            } finally {
                setLoading(false);
            }
        };

        fetchBaseData();
    }, []);

    useEffect(() => {
        if (selectedTypeId) {
            setFormData(prev => ({
                ...prev,
                accountType: accountTypes.find(type => type.id === selectedTypeId),
                first_name: localFormValues.first_name,
                last_name: localFormValues.last_name,
                business_name: localFormValues.business_name,
                role_id: localFormValues.role_id,
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                accountType: '',
                first_name: '',
                last_name: '',
                business_name: '',
                role_id: '',
            }));
        }
    }, [selectedTypeId, localFormValues, accountTypes, setFormData]);

    const handleTypeChange = (id) => {
        setSelectedTypeId(id);
        setLocalFormValues({
            first_name: '',
            last_name: '',
            business_name: '',
            role_id: '',
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLocalFormValues((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div>
            <Helmet>
                <title>Select Account Holder Type</title>
            </Helmet>

            <div className="payout-setup">
                <div className="ws-cl-header">
                    <div>
                        <h4 className="ws-title">Who owns this bank account?</h4>
                        <p className="ws-desc">Choose the account type</p>
                    </div>
                </div>

                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <div className="payment-options">
                            {accountTypes.map((type) => (
                                <div className={`po-form-box ${selectedTypeId === type.id ? 'selected' : ''}`} key={type.id}>
                                    <div className='form-flex form-icon-box'>
                                        <div className='form-icon'>
                                            <img 
                                            src='/assets/img/icons/pointer_icon.svg'
                                            className='form-icon img-fluid'
                                            alt=''
                                            />
                                        </div>
                                        <div className='form-txt drawer-policy-box mb-0'>
                                            <label className="policy-radio-input">
                                                <div className="policy-radio-txt-box">
                                                    <span>{type.title}</span>
                                                </div>
                                                <div className={`circle ${selectedTypeId === type.id ? 'active' : ''}`}></div>
                                                <input
                                                    type="radio"
                                                    name="account_type"
                                                    value={type.id}
                                                    checked={selectedTypeId === type.id}
                                                    onChange={() => handleTypeChange(type.id)}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {selectedTypeId === 1 && (
                            <div className="form-fields">

                                <div className="po-form-box">
                                    <div className='form-flex form-icon-box'>
                                        <div className='form-icon'>
                                            <img 
                                            src='/assets/img/icons/pointer_icon.svg'
                                            className='form-icon img-fluid'
                                            alt=''
                                            />
                                        </div>
                                        <div className='form-txt'>
                                            <div className='form-floating'>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="first_name"
                                                    name="first_name"
                                                    value={localFormValues.first_name}
                                                    onChange={handleInputChange}
                                                />
                                                <label htmlFor="first_name">First Name</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="po-form-box">
                                    <div className='form-flex form-icon-box'>
                                        <div className='form-icon'>
                                            <img 
                                            src='/assets/img/icons/pointer_icon.svg'
                                            className='form-icon img-fluid'
                                            alt=''
                                            />
                                        </div>
                                        <div className='form-txt'>
                                            <div className='form-floating'>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="last_name"
                                                    name="last_name"
                                                    value={localFormValues.last_name}
                                                    onChange={handleInputChange}
                                                />
                                                <label htmlFor="last_name">Last Name</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="po-form-box">
                                    <div className='form-flex form-icon-box'>
                                        <div className='form-icon'>
                                            <img 
                                            src='/assets/img/icons/pointer_icon.svg'
                                            className='form-icon img-fluid'
                                            alt=''
                                            />
                                        </div>
                                        <div className='form-txt'>
                                            <div className="form-floating">
                                                <select
                                                    className="form-select"
                                                    id="role_id"
                                                    name="role_id"
                                                    value={localFormValues.role_id}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select</option>
                                                    {roles.map((role) => (
                                                        <option key={role.id} value={role.id}>
                                                            {role.title}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor="role_id">Role</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        )}

                        {selectedTypeId === 2 && (
                            <div className="form-fields">

                                <div className="po-form-box">
                                    <div className='form-flex form-icon-box'>
                                        <div className='form-icon'>
                                            <img 
                                            src='/assets/img/icons/pointer_icon.svg'
                                            className='form-icon img-fluid'
                                            alt=''
                                            />
                                        </div>
                                        <div className='form-txt'>
                                            <div className='form-floating'>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="business_name"
                                                    name="business_name"
                                                    value={localFormValues.business_name}
                                                    onChange={handleInputChange}
                                                />
                                                <label htmlFor="business_name">Business Name</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="po-form-box">
                                    <div className='form-flex form-icon-box'>
                                        <div className='form-icon'>
                                            <img 
                                            src='/assets/img/icons/pointer_icon.svg'
                                            className='form-icon img-fluid'
                                            alt=''
                                            />
                                        </div>
                                        <div className='form-txt'>
                                            <div className="form-floating">
                                                <select
                                                    className="form-select"
                                                    id="role_id"
                                                    name="role_id"
                                                    value={localFormValues.role_id}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select</option>
                                                    {roles.map((role) => (
                                                        <option key={role.id} value={role.id}>
                                                            {role.title}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor="role_id">Role</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default AccountType;